import { UserPermission } from '@cobliteam/common-types/';

const MediaPermissions = {
  VIEW_CAMERA_MEDIA: UserPermission.VIEW_CAMERA_MEDIA,
  REQUEST_CAMERA_MEDIA: UserPermission.REQUEST_CAMERA_MEDIA,
  UPDATE_DRIVER_FACE_CLUSTER: UserPermission.UPDATE_DRIVER_FACE_CLUSTER,
  CONFIG_AND_VIEW_CUSTOM_ALERTS: UserPermission.CONFIG_AND_VIEW_CUSTOM_ALERTS,
};

export default MediaPermissions;
